// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2004":"cbb7591b08404c14","5298":"f760222408b0bacd"}[chunkId] + ".js";
};